import BaseModel from '../base';

import User from '@/utils/user';

import constants from './constants';
import glossary from './glossary';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { getInviteLink } from '@/modules/UIDesign/Invites/functions';
import { INVITE_TYPE } from '@/modules/UIDesign/Invites/constants';
import { STATUS_DATA } from './member/glossary';

export default class Club extends BaseModel {
  #user;

  constructor(item = {}, url) {
    super(item, url);

    this.name = item.name;
    this.description = item.description;
    this.image = item.image;
    this.my_request = item.my_request || null;
    this.my_request_status = item.my_request_status ?? this.my_request?.status ?? null;
    this.representative_offices = item.representative_offices;

    this.members_count = item.members_count || 0;
    this.supervisors_count = item.supervisors_count || 0;
    this.teams_count = item.teams_count || 0;
    this.owner = item.owner || undefined;

    this.#user = new User();
  }

  get isOwner() {
    return this.#user?.isAuthenticated && this.owner?.id === this.#user?.data?.id;
  }

  get statusData() {
    const status = this.my_request?.status ?? this.my_request_status;
    return status ? STATUS_DATA?.[status] : undefined;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  get inviteLink() {
    const getMethod = (methodType) => rHandler(
      apiService?.[methodType]?.(`${this.url}/${this.id}/invite`),
      (response) => ({
        response,
        item: getInviteLink(response?.data?.data?.invite || '', INVITE_TYPE.clubMember),
      }),
      (error) => ({ error }),
    );
    return {
      get: () => getMethod('get'),
      refresh: () =>  getMethod('post'),
    };
  }
}
